import StandardProtect from './standard_protect.vue';

export default StandardProtect;
